<template>
  <div class="user-agreement">
    <div class="overflow-hidden wrapper" ref="content">
      <div class="scroller" ref="scroller">
        <div class="body p-3">
          <p><strong>სამომხმარებლო შეთანხმება</strong></p>
          <p>
            მადლობა, რომ ეწვიეთ MYDOC-ს, ჯამრთელობაზე ორიენტირებულ ონლაინ
            სერვისს. გთხოვთ ყურადღებით გადახედოთ ჩვენი მომსახურების პირობებს და
            დაეთანხმოთ მას.
          </p>
          <p>
            იმ შემთხვევაში, თუ თქვენ არ ეთანხმებით მოცემულ პირობებს, გთხოვთ
            დაუყოვნებლივ დატოვოთ ჩვენი ვებ-გვერდი (აპლიკაცია) და არ სცადოთ
            მომსახურების გამოყენება.
          </p>
          <p>
            MYDOC წარმოადგენს შპს &bdquo;ტელეკლინიკის&ldquo; ონლაინ პლატფორმას
            &nbsp;&bdquo;ტელეკლინიკა&ldquo; (შემდგომში კომპანია) არის
            საქართველოს კანონმდებლობის თანახმად რეგისტრირებული იურიდიული პირი.
            საიდენტიფიკაციო ნომერი: 405349859
          </p>
          <p>ფაქტიური მისამართი: თბილისი ა. წერეთლის გამზირი 2 ოფისი 5</p>
          <p>
            წინამდებარე &bdquo;სამომხმარებლო შეთანხმება&ldquo;&nbsp; წარმოადგენს
            მომხმარებელსა &nbsp;და MYDOC-ს შორის გაფორმებულ იურიდიულ
            შეთანხმებას&nbsp; მომსახურების&nbsp; გამოყენებასთან დაკავშირებით.
          </p>
          <p>
            MYDOC ზე რეგისტრაციისთანავე&nbsp; თქვენ უპირობოდ ეთანხმებით ამ
            შეთანხმებით გათვალისწინებულ ყველა პირობას.
          </p>
          <p>
            MYDOC &nbsp;უფლებას იტოვებს, წინამდებარე შეთანხმების ნებისმიერი
            ნაწილი ნებისმიერი მიზეზით შეცვალოს ან გააუქმოს ნებისმიერ დროს,
            ამასთან დაკავშირებით ინფორმაციის აუცილებელი მიწოდების დათქმით.
          </p>
          <p><strong>მომხმარებლის ანგარიში</strong></p>
          <p>
            იმისათვის რომ ისარგებლოთ MYDOC &nbsp;ის სერვისებით უნდა იყოთ 18 წლის
            ან მეტის.
          </p>
          <p>
            თუ მომხმარებელი დარეგისტრირებულია MYDOC ზე, იგი პასუხისმგებელია
            საკუთარი ანგარიშის წვდომაზე და განკუთვნილი ინფორმაციისა და პაროლის
            კონფიდენციალურობის დაცვაზე. მომხმარებელი პასუხისმგებელია საკუთარი
            ანგარიშისა და პაროლის ნებისმიერი სახის გამოყენებაზე.
          </p>
          <p>
            მომხმარებელმა დაუყოვნებლივ უნდა აცნობოს MYDOC-ს საკუთარი ანგარიშის
            ან პაროლის უნებართვო გამოყენების ნებისმიერი ფაქტისა შესახებ.
            ამასთან, MYDOC არ იქნება პასუხისმგებელი იმ ზიანისთვის, რომელიც
            შესაძლოა დადგეს მომხმარებლის ანგარიშის უნებართვო გამოყენების
            შედეგად.
          </p>
          <p>
            მომხმარებელს შესაძლოა პასუხისმგებლობა დაეკისროს MYDOC-ის ან სხვა
            რომელიმე პირისათვის მიყენებული ზიანისთვის, რომელიც დადგა
            მომხმარებლის ანგარიშის უნებართვო გამოყენების შედეგად.
          </p>
          <p>
            <strong>MYDOC ის მომ</strong><strong>ს</strong
            ><strong>ახურება მოიცავს</strong><strong>:</strong>
          </p>
          <ul>
            <li>პაციენტის სიმპტომების წინასაწარ შეფასებას;</li>
            <li>
              ლიცენზირებული ექიმების მიერ ონლაინ ვიდეო კონსულტაციების
              განხორციელებას;
            </li>
            <li>სხვადასხვა სამედიცინო სერვისებზე ჩაწერას;</li>
            <li>სხვადასხვა სამედიცინო სერვისების ბინაზე გამოძახებას;</li>
            <li>
              საკუთარ ჯანმრთელობისთან დაკავშირებული სამედიცინო ჩანაწერების
              (ისტორიის) უსაფრთხო შენახვასა და წვდომას;
            </li>
            <li>მომსახურების ღირებულების წინასწარ გადახდას.</li>
          </ul>
          <p>
            MYDOC საშუალებას აძლევს მომხმარებლებს, დაუკავშირდნენ ექიმებს,
            სამედიცინო დაწესებულებებს დაჯავშნის მეშვეობით:
          </p>
          <p>
            მომხმარებელი ვალდებულია წინასწარ გადაიხადოს ვიზიტის საფასური და
            შემდეგ ეწვიოს ექიმს/სამედიცინო დაწესებულებას.
          </p>
          <p>
            MYDOC სერვისები &nbsp;არ არის გამიზნული იმისათვის, რომ შეცვალოს
            გადაუდებელი სამედიცინო დახმარება. თუ მომხმარებელს სჭირდება
            გადაუდებელი სამედიცინო დახმარება, იგი &nbsp;უშუალოდ უნდა
            დაუკავშირდეს სასწრაფო დახმარების სამსახურს ან სამედიცინო
            დაწესებულებას.
          </p>
          <p>
            <strong>დაჯავშნილი </strong
            ><strong>სერვისის გაუქმების და თანხის დაბრუნების </strong
            ><strong>წესები</strong>
          </p>
          <p>
            სერვისის წინასწარ გაუქმების გარეშე პაციენტის გამოუცხადებლობა
            ფიზიკურად კლინიკაში, ან მისი ტელეკონსულტაციის დაჯავშნული დროისათვის
            ონლაინ ხელმიუწვდომლობა, განიხილება მომხმარებლის მხრიდან წესების
            დარღვევად და მას გადახდილი თანხა არ აუნაზღაურდება .
          </p>
          <p>
            ვიზიტზე, ტელეკონსულტაციაზე დაგვიანების მაქსიმალური ხანგძლივიბა
            განისაზღვრება 15 წუთით.
          </p>
          <p>
            თუ პაციენტს არ შეუძლია ექიმთან დანიშნულ ვიზიტზე გამოცხადება (ვიზიტი
            კლინიკაში, დისტანციური კონსულტაცია ან სახლში ვიზიტი), მან წინასწარ
            უნდა გააუქმოს აღნიშნული ვიზიტი.
          </p>
          <p>
            პაციენტს შეუძლია გააუქმოს ვიზიტი 1 საათით ადრე და ამ შემთხვევაში მას
            აქვს უფლება სრულად დაიბრუნოს გადახდილი თანხა.
          </p>
          <p>
            მომხმარებელს აქვს უფლება დანიშნოს ვიზიტის ახალი ვადა და ამ
            შემთხვევაში იგი არ იხდის დამატებით თანხას.
          </p>
          <p>
            როდესაც მომხმარებელი არ ცხადდება დათქმულ შეხვედრაზე (შეხვედრის
            დათქმული დღის დადგომამდე, წინასწარი გაუქმების გარეშე), ექიმებს,
            რომლებიც MYDOC-ს იყენებენ, შეუძლიათ მონიშნონ შესაბამისი ვიზიტი,
            როგორც პაციენტის გამოუცხადებლობა.
          </p>
          <p>
            თუ პაციენტი გააუქმებს ექიმთან ვიზიტს (კლინიკაში ვიზიტს, ვიდეო
            კონსულტაციას ან სახლში ვიზიტს) დანიშნული ვიზიტამდე &nbsp;1 საათით ან
            უფრო ადრე, MYDOC აუნაზღაურებს მას წინასწარ გადახდილ სრულ თანხას ხუთი
            (5) სამუშაო დღის განმავლობაში.
          </p>
          <p>
            პაციენტს არ აუნაზღაურდება გადახდილი თანხა იმ შემთხვევებში,
            როდესაც&nbsp; &nbsp;პაციენტი ექიმთან კონტაქტზე გადის 30 წუთზე მეტი
            დაგვიანებით;
          </p>
          <p>
            იმ შემთხვევაში, თუ ექიმმა, რომელთანაც პაციენტმა შეხვედრა დაჯავშნა
            MYDOC-ის მეშვეობით და წინასწარ გადაიხადა სერვისის საფასური, ვერ
            შეძლო პაციენტთან შეხვედრა, ან ექიმის შეფერხება 60 წუთს აღემატება,
            მომხმარებელმა უნდა
          </p>
          <p>
            მოგვწეროს შემდეგი ელექტრონული ფოსტის მისამართზე: support@mydoc.ge ამ
            შემთხვევაში, პაციენტს კონსულტაციის მთელი გადახდილი საფასური
            აუნაზღაურდება მომდევნო 5 სამუშაო დღის განმავლობაში.&nbsp;
          </p>
          <p>
            <strong
              >კონტენტზე საკუთრების უფლება და&nbsp; საავტორო უფლებები</strong
            >
          </p>
          <p>MYDOC&nbsp; კონტენტი მოიცავს:</p>
          <ul>
            <li>მომხმარებლის სახელსა და გვარს;</li>
            <li>მომხმარებლის მისამართს;</li>
            <li>
              საკონტაქტო მონაცემებს (ელექტრონული ფოსტა და ტელეფონის ნომერი);
            </li>
            <li>დემოგრაფიულ ცნობებს (სქესი, დაბადების თარიღი);</li>
            <li>პირად ნომერსა ან სხვა საიდენტიფიკაციო დოკუმენტის ნომერს;</li>
            <li>
              ინფორმაციას მომხმარელის მიერ &bdquo;სერვისების&ldquo; გამოყენების
              შესახებ;
            </li>
            <li>
              ჯანმრთელობის მონაცემებს - დიაგნოზებს, დასკვნებს, კვლევათა
              შედეგებს, რეცეპტებს, მედიკამენტებს, ექიმთან დანიშნულ ვიზიტებს და
              ა.შ.;
            </li>
            <li>
              MYDOC-ს საშუალებით შეძენილი სერვისების საფასურის გადახდის
              ოპერაციებს;
            </li>
            <li>
              მომხმარებლის ფოტოებსა და სხვა მის მიერ მოწოდებულ გამოსახულებებს;
            </li>
          </ul>
          <p>
            ინფორმაცია, რომელსაც MYDOC უშუალოდ ან არაპირდაპირი გზით აგროვებს
            &bdquo;მომხმარებლებისა&ldquo; და ექიმებისგან/სამედიცინო
            დაწესებულებებისგან, MYDOC-ს ეკუთვნის.
          </p>
          <p>
            MYDOC-ს მიერ &bdquo;აპლიკაციაში&ldquo; გამოქვეყნებული და საავტორო
            უფლებებით დაცული კონტენტის კოპირება ნებისმიერი კომერციული მიზნისთვის
            ან მოგების მისაღებად, საავტორო უფლებების დარღვევა იქნება და MYDOC
            დაიცავს თავის უფლებებს მოქმედი კანონმდებლობის შესაბამისად.
          </p>
          <p>
            ჩანაწერები ჯანმრთელობის მდგომარეობის შესახებ მოიცავს პაციენტის
            სიმპტომებს, რისკფაქტორებს, დასმულ დიაგნოზებსა და დანიშნულებებს,
            ლაბორატორიული და ინსტრუმენტალური კვლევების შედეგებსა და დასკვნებს.
          </p>
          <p>
            ჯანმრთელობის შესახებ ჩანაწერები გადაიგზავნება მომხმარებლის
            ანგარიშზე,
          </p>
          <p>
            MYDOC იცავს გონივრულ უსაფრთხოებას&nbsp; მომხმარებლის პროფილთან და
            ჯანმრთელობის ჩანაწერთან მიმართებით. ამასთან, MYDOC არ იძლევა
            გარანტიას, რომ აღუდგება არასანქცირებულ წვდომას, თუ მომხმარებელი
            თავად დაკარგავს MYDOC ში შესასვლელ საიდენტიფიკაციო მონაცემებს.
          </p>
          <p>
            გთხოვთ, მაქსიმალურად დაიცვათ თქვენი ავტორიზაციის ინფორმაცია და
            შეგვატყობინოთ ანგარიშის ფაქტობრივი თუ სავარაუდო დარღვევის/შეღწევის
            შესახებ შემდეგ მისამართზე: support@MYDOC.ge.
          </p>
          <p>
            MYDOC დაიცავს საქართველოს კანონმდებლობის მოთხოვნებს და შეზღუდვებს
            ჯანმრთელობის ჩანაწერების გაზიარების ნებისმიერ შემთხვევასთან
            დაკავშირებით.
          </p>
          <p><strong>აკრძალვები და შეზღუდვები</strong></p>
          <p>მომხმარებლებს&nbsp; ეკრძალებათ:</p>
          <p>არასრული, ყალბი ან არაზუსტი ინფორმაციის განთავსება;</p>
          <p>
            მომხმარებლის მიერ მოქმედი კანონმდებლობის, წესების ან დებულებების ან
            ამ შეთანხმების &nbsp;შეუსრულებლობის შემთხვევაში, MYDOC-ს უფლება
            აქვს, დაუყოვნებლივ შეწყვიტოს მომხმარებლის წვდომა &nbsp;MYDOC ზე.
          </p>
          <p>
            MYDOC-ს უფლება აქვს, გაამჟღავნოს ან გასცეს მომხმარებლის პერსონალური
            ინფორმაცია მხოლოდ იმ შემთხვევაში, თუ აღნიშნული მოთხოვნილია კანონით,
            სამართალდამცავი ორგანოს მიერ, ან როდესაც MYDOC, თავისი
            შეხედულებისამებრ, საჭიროდ თვლის, შეებრძოლოს თაღლითობას.
          </p>
          <p>
            MYDOC უფლებას იტოვებს, შეტყობინების გარეშე შეაჩეროს ან შეწყვიტოს
            მომხმარებლის &nbsp;წვდომა სერვისებზე &nbsp;და ასევე, გამოიყენოს
            კანონით გათვალისწინებული ნებისმიერი სხვა საშუალება იმ შემთხვევებში,
            როდესაც:
          </p>
          <p>მომხმარებელი არღვევს შეთანხმების პირობებს;</p>
          <p>
            MYDOC ვერ ახდენს მომხმარებლის მიერ MYDOC-სთვის მიწოდებული
            ინფორმაციის ვერიფიკაციას ან ავთენტურობის დადგენას;
          </p>
          <p>
            MYDOC-ს აქვს საფუძვლიანი ეჭვი მომხმარებლის მხრიდან&nbsp; უკანონო,
            თაღლითური ქმედების შესახებ;
          </p>
          <p><strong>დავები</strong></p>
          <p>
            ნებისმიერი დავა, პრეტენზია ან უთანხმოება, რომელიც წარმოიშობა
            წინამდებარე შეთანხმებიდან გამომდინარე განიხილება საქართველოს
            შესაბამისი სასამართლოების მიერ.
          </p>
          <p>
            MYDOC-ს მომხმარებლებს დახმარების მისაღებად, შეუძლიათ, მოგვმართოთ
            ელ.ფოსტის შემდეგ მისამართზე: support@MYDOC.ge.
          </p>
          <p><strong>კონფიდენციალურობის პოლიტიკა</strong></p>
          <p>
            MYDOC იღებს ვალდებულებას, დაიცვას მომხმარებლის &nbsp;კონფიდენციალობა
            და მისი პერსონალური მონაცემები.
          </p>
          <p>
            წინამდებარე &bdquo;მონაცემთა დაცვის პოლიტიკა&ldquo; შემუშავებულია
            პერსონალურ მონაცემთა დაცვის შესახებ საქართველოს კანონის შესაბამისად
            თუ თქვენ არ ეთანხმებით მონაცემთა დამუშავების იმ მეთოდებს, რომლებიც
            აღწერილია ამ დოკუმენტში, არ უნდა გამოიყენოთ MYDOC ან მისი რომელიმე
            სერვისი.
          </p>
          <p>
            <strong>პერსონალური მონაცემების შეგროვება და დამუშავება</strong>
          </p>
          <p>
            MYDOC აგროვებს და ამუშავებს პერსონალურ მონაცემებს, რომლებიც
            აუცილებელია იმისათვის, რომ მოგეწოდოთ სერვისები ასევე, სტატისტიკური
            ანალიზისა და ბიზნესის კვლევისთვის მხოლოდ აგრეგირებული ან
            დეპერსონალიზებული ფორმით.
          </p>
          <p>პერსონალური მონაცემები:</p>
          <ul>
            <li>მუშავდება კანონიერად, სამართლიანად და გამჭვირვალედ;</li>
            <li>გროვდება მხოლოდ კონკრეტული და ლეგიტიმური მიზნებისთვის;</li>
            <li>
              არის ზუსტი და, საჭიროების შემთხვევაში, ხდება მათი განახლება;
            </li>
            <li>
              ინახება იმ ფორმით, რომელიც იძლევა მონაცემთა სუბიექტების
              იდენტიფიცირების შესაძლებლობას, ინახება ასეთი მონაცემთა დამუშავების
              მიზნებისთვის საჭირო ვადის განმავლობაში.
            </li>
            <li>
              &bdquo;თქვენ&ldquo; ეთანხმებით ზემოხსენებული მიზნებისთვის ასეთი
              ინფორმაციის შეგროვებას და დამუშავებას MYDOC-ს მიერ.
            </li>
            <li>
              ინფორმაცია, რომელსაც &bdquo;თქვენგან&ldquo; შევაგროვებთ და
              დავამუშავებთ,&nbsp; მოიცავს შემდეგს:
            </li>
            <li>მომხმარებლის სახელი და გვარი;</li>
            <li>მისამართი;</li>
            <li>
              საკონტაქტო მონაცემები&nbsp; ელექტრონული ფოსტის მისამართი და
              ტელეფონის ნომერი;
            </li>
            <li>
              დემოგრაფიული მონაცემები (როგორიცაა, სქესი და დაბადების თარიღი);
            </li>
            <li>პირადი&nbsp; საიდენტიფიკაციო ნომერი;</li>
            <li>მონაცემები სერვისების გამოყენების შესახებ;</li>
            <li>მონაცემები ჯანმრთელობის მდგომარეობის შესახებ,</li>
          </ul>
          <p>
            სხვა ინფორმაცია, რომელსაც მომხმარებელი ნებაყოფლობით გადაწყვეტს, რომ
            მოგვაწოდოს
          </p>
          <p>
            თუ მომხმარებელი აღარ სურს გამოვიყენოთ მისი ინფორმაცია მისთვის
            სერვისების მოსაწოდებლად, იგი უნდა დაგვიკავშირდეს &nbsp;მისამართზე:
            support@MYDOC.ge. MYDOC ატარებს უსაფრთხოების სათანადო ზომებს და
            პროცედურებს, რომ დაიცვას მისი კონტროლის ქვეშ არსებული პერსონალური
            მონაცემები არაუფლებამოსილი წვდომისგან, არასწორი გამოყენებისა და
            გამჟღავნებისგან, არაუფლებამოსილი მოდიფიცირებისა და უკანონო
            განადგურებისგან ან შემთხვევითი დაკარგვისგან.
          </p>
          <p>მომხმარებელი სარგებლობს მონაცემთა დაცვის შემდეგი უფლებებით:</p>
          <p>
            მომხმარებლის შესახებ არსებულ ინფორმაციასთან წვდომის, ინფორმაციის
            განახლების ან წაშლის უფლება.&nbsp;
          </p>
          <p>
            თუ მომხმარებელს აღარ სურთ, რომ MYDOC-მ დაამუშაოს მისი პერსონალური
            ინფორმაცია, იგი უნდას &nbsp;დაგვიკავშირდით შემდეგ მისამართზე:
            support@MYDOC.ge.
          </p>
          <p>
            დამატებითი ინფორმაციისთვის, მომხმარებელი შეიძლება დაუკავშირდეს
            სახელმწიფო ინსპექტორის სამსახურს შემდეგი ვებ-გვერდის მეშვეობით:
            <a href="https://personaldata.ge">https://personaldata.ge</a>.
          </p>
          <p>
            MYDOC ს უფლება აქვს, ნებისმიერ დროს განაახლოს კონფიდენიციალურობის
            პოლიტიკა. მასში &nbsp;არსებითი ცვლილებების განხორციელების
            შემთხვევაში, აღნიშნული ცვლილებების თაობაზე შეტყობინება გაეგზავნება
            ყველა მომხმარებელს
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  metaInfo: {
    title: 'User Agreement'
  },
  mounted () {
    this.setNavVisible(false)
    // this.headGoBack()
    this.setHead({ url: -1, text: this.$t('userAgreement') })
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setNavVisible: 'app/setNavVisible',
      setHead: 'head/set',
      resetHead: 'head/reset'
    })
  }
}
</script>
<style lang="scss">
.user-agreement {
  .body {
    font-size: 0.75em;
  }
}
</style>
<i18n>
{
  "ka": {
    "userAgreement": "სამომხმარებლო შეთანხმება"
  }
}
</i18n>
